export const environment = {
  production: false,
  portal_name: 'Cropmap',
  mapboxAccessToken: 'pk.eyJ1IjoiZ2VvZGF0YWRldiIsImEiOiJjajd6ejNnZWY2YXphMnFwZmh4Y2h6N2c4In0.qQOAcXvx6GxJgEo3UYYVAA',
  /* Languages */
  languages: ['en', 'fr', 'nl'],
  defaultLanguage: 'en'
};



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Angular_wig_cropmap_master/src/environments/environment.ts